import { render, staticRenderFns } from "./PaginaConstrucao.vue?vue&type=template&id=57411d1c&"
import script from "./PaginaConstrucao.vue?vue&type=script&lang=js&"
export * from "./PaginaConstrucao.vue?vue&type=script&lang=js&"
import style0 from "./PaginaConstrucao.vue?vue&type=style&index=0&id=57411d1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports